"use client";

import React, { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeritageHospitality() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return <section data-section-id="223889" id="our-heritage" className="bg-background text-foreground relative w-full min-h-screen flex items-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 opacity-[0.08] pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/mountain_mist_texture.png)] bg-repeat mix-blend-overlay" aria-hidden="true" />

      <div className="container mx-auto px-4 py-20 md:py-32 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-center">
          
          {}
          <div ref={imgRef} className={`lg:col-span-5 relative h-[60vh] lg:h-[85vh] w-full overflow-hidden rounded-none transition-all duration-1000 ease-out ${isImgVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="absolute inset-0 w-full h-[120%] -top-[10%] will-change-transform" style={{
            transform: `translateY(${scrollY * 0.15}px)`
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/frontier_founders_portrait.png" alt="Frontier North Founders" className="w-full h-full object-cover object-center grayscale contrast-125" />
              {}
              <div className="absolute inset-0 bg-secondary/10 mix-blend-multiply" />
            </div>
          </div>

          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-center space-y-10 lg:pl-8 xl:pl-16 transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="space-y-6">
              <h2 className="font-serif text-4xl md:text-5xl lg:text-7xl font-light tracking-tight text-secondary">
                Small-group motorbike journeys
              </h2>
              <div className="w-20 h-[1px] bg-primary/40" />
            </div>

            <div className="space-y-6 text-muted-foreground font-default text-lg md:text-xl leading-relaxed max-w-2xl">
              <p>
                The Ha Giang Loop reveals a landscape of raw, cinematic scale. We believe 
                the true spirit of the frontier is found in the silence of limestone 
                peaks and the genuine warmth of a mountain home. This is a premium, 
                curated journey designed for those seeking depth over distance.
              </p>
              <p>
                Discover the legendary Easy Rider experience alongside professional 
                pilots who navigate every hidden bend with precision. By limiting our 
                groups to just six guests, we ensure an intimate connection with the 
                land—offering quiet roads, authentic heritage, and an unrivaled perspective.
              </p>
            </div>

            <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center gap-8 border-t border-border/20">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/frontier_north_seal.png" alt="Frontier North Seal" className="h-14 object-contain opacity-80 filter brightness-0" />
              <div className="sm:ml-auto">
                <Button asChild variant="outline" size="lg" className="rounded-none border-secondary/20 hover:bg-secondary hover:text-secondary-foreground transition-colors font-default tracking-widest uppercase text-xs">
                  <Link to="https://frontiernorthvietnam.com/reserve-your-seat/">Reserve Your Seat</Link>
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}